module.exports = __webpack_public_path__ + "static/media/MU.1b6cd1f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MU.svg
// module id = 320
// module chunks = 0